import {atom} from 'jotai'

export const meniAtom = atom({})